import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "build__class" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.soldierClass !== 'custom')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("img", {
            src: 
					require('@/assets/soldier_icons/' +
						_ctx.getSoldierData('id', _ctx.soldierClass, 'icon'))
				,
            alt: "",
            class: "build__class-icon"
          }, null, 8, _hoisted_2),
          _createElementVNode("p", null, _toDisplayString(_ctx.getSoldierData('id', _ctx.soldierClass, 'name')), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("img", {
            src: require('@/assets/soldier_icons/tags.svg'),
            alt: "",
            class: "build__class-icon"
          }, null, 8, _hoisted_3),
          _createElementVNode("p", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, idx) => {
              return (_openBlock(), _createElementBlock("span", { key: tag }, _toDisplayString(_ctx.convertSkillTagToName(tag)) + _toDisplayString(idx + 1 < _ctx.tags.length ? ', ' : ''), 1))
            }), 128))
          ])
        ], 64))
  ]))
}